import { createAction } from "@reduxjs/toolkit";
import type { GenerateCoverLetterBody, GenerateCoverLetterResponse } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const generateCoverLetter = createApiThunk<GenerateCoverLetterResponse, GenerateCoverLetterBody>(
  "coverLetter/generate",
  async (body: GenerateCoverLetterBody, { extra: { studentRepository } }) => {
    return studentRepository!.generateCoverLetter(body);
  },
);

export const resetGenerateCoverLetter = createAction("student/resetGenerateCoverLetter");
